import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "week-title" }
const _hoisted_2 = {
  key: 0,
  class: "event total-hours"
}
const _hoisted_3 = { class: "event-container" }
const _hoisted_4 = {
  key: 0,
  class: "event-tooltip"
}
const _hoisted_5 = {
  key: 1,
  class: "event-tooltip"
}
const _hoisted_6 = { class: "event__title" }
const _hoisted_7 = { class: "event__body" }
const _hoisted_8 = { class: "event__name" }
const _hoisted_9 = { class: "event__description" }
const _hoisted_10 = { class: "event__action mr-3" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "effort" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "float-right" }
const _hoisted_17 = {
  key: 0,
  class: "float-right"
}
const _hoisted_18 = {
  key: 1,
  class: "float-right"
}
const _hoisted_19 = {
  key: 2,
  class: "new-event event"
}
const _hoisted_20 = { class: "event__body" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "cm-color-list"
}
const _hoisted_24 = {
  key: 0,
  class: "week-statistic"
}
const _hoisted_25 = { class: "commitment-names" }
const _hoisted_26 = { class: "chart-container" }
const _hoisted_27 = { class: "chart chart--show-percent" }
const _hoisted_28 = { class: "chart" }
const _hoisted_29 = {
  class: "chart chart--arrow",
  style: {"display":"flex"}
}
const _hoisted_30 = { class: "hours" }
const _hoisted_31 = {
  class: "arrow-item",
  style: 'width: 100%;'
}
const _hoisted_32 = { class: "hours" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_RegisterLeave = _resolveComponent("RegisterLeave")!
  const _component_TimesheetRegister = _resolveComponent("TimesheetRegister")!
  const _component_timesheet_clone = _resolveComponent("timesheet-clone")!
  const _component_adjustment = _resolveComponent("adjustment")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { loading: _ctx.checkLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  icon: "mdi-chevron-left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPrevWeekClicked()))
                }),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.weekTitle()), 1),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  icon: "mdi-chevron-right",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNextWeekClicked()))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { style: {"overflow":"auto"} }, {
          default: _withCtx(() => [
            _createVNode(_component_FullCalendar, {
              class: "timesheet-calendar",
              options: _ctx.calendarOptions,
              ref: "fullCalendar"
            }, {
              eventContent: _withCtx((arg) => [
                (arg.event.extendedProps.type === 'total-hours')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_tooltip, {
                          location: "top",
                          show: "",
                          width: "300",
                          class: "event-tooltip-container"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("div", _mergeProps(props, { class: "event__header" }), _toDisplayString(arg.event.title), 17)
                          ]),
                          default: _withCtx(() => [
                            (arg.event.extendedProps.originalObject && arg.event.extendedProps.originalObject.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arg.event.extendedProps.originalObject, (c) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "commitment",
                                      key: c.commitmentName
                                    }, "  " + _toDisplayString(c.Name) + " : " + _toDisplayString(_ctx.hoursOfCommitment(c.id, arg.event.start.getDay())) + " Hours ", 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_5, "There are no any data"))
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  : (arg.event.extendedProps.type === 'leave' || arg.event.extendedProps.type === 'timesheet')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "event main-event",
                        style: _normalizeStyle({ background: `${arg.event.backgroundColor} !important` })
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(arg.event.extendedProps.type === "timesheet" ? "Timesheet" : "Leave"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(arg.event.title), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(arg.event.extendedProps.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          (!_ctx.isLessThanSixDays(arg.event.end))
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                top: ""
                              }, {
                                activator: _withCtx(({ props }) => [
                                  (!_ctx.isCustomer && !arg.event.extendedProps.isDisabled)
                                    ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                                        disabled: true,
                                        class: "action-icon",
                                        onClick: ($event: any) => (_ctx.onDelete($event, arg.event.extendedProps))
                                      }), {
                                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                                          _createTextVNode("mdi-delete")
                                        ])),
                                        _: 2
                                      }, 1040, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx(() => [
                                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "You can only edit or delete the last 6 days.", -1))
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (!_ctx.isCustomer && !arg.event.extendedProps.isDisabled)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "action-icon",
                                      onClick: ($event: any) => (_ctx.onDelete($event, arg.event.extendedProps))
                                    }, {
                                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                                        _createTextVNode("mdi-delete")
                                      ])),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])),
                          (!_ctx.isCustomer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (arg.event.extendedProps.type === 'timesheet')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      icon: "",
                                      class: "action-icon",
                                      onClick: ($event: any) => (_ctx.onClone($event, arg.event.extendedProps))
                                    }, {
                                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                                        _createTextVNode("mdi-content-copy")
                                      ])),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isAdmin || _ctx.isCustomer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (arg.event.extendedProps.type === 'timesheet' && !arg.event.isDisabled && _ctx.isLessThanSixDays(arg.event.end))
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "action-icon",
                                      onClick: ($event: any) => (_ctx.onAdjustment($event, arg.event.extendedProps))
                                    }, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode("mdi-update")
                                      ])),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_14, [
                            (arg.event.extendedProps.type === 'timesheet')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(arg.event.extendedProps.originalObject.Effort) + "H ", 1),
                                  _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                                  (arg.event.extendedProps.originalObject.Adjustment)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(arg.event.extendedProps.originalObject.Adjustment > 0 ? `+` : ``) + _toDisplayString(arg.event.extendedProps.originalObject.Adjustment) + "H ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(arg.event.extendedProps.originalObject.Hours) + "H ", 1))
                          ])
                        ])
                      ], 4))
                    : (arg.event.extendedProps.type === 'event' && !_ctx.isCustomer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "event__title" }, [
                            _createElementVNode("span", null, "New Event")
                          ], -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", {
                              class: "event__add add--timesheet",
                              onClick: ($event: any) => (_ctx.registerTimesheet(arg.event))
                            }, "Add TimeSheet", 8, _hoisted_21),
                            _createElementVNode("div", {
                              class: "event__add add--leave",
                              onClick: ($event: any) => (_ctx.registerLeave(arg.event))
                            }, "Add Leave", 8, _hoisted_22)
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading"]),
    (!_ctx.checkLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredCommitmentList(), (cm) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cm.id,
              class: "cm-item"
            }, [
              _createElementVNode("span", {
                class: "color-box",
                style: _normalizeStyle({ background: cm.color })
              }, null, 4),
              _createElementVNode("span", null, _toDisplayString(cm.Name), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checkLoading)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Total Hours Of This Week: " + _toDisplayString(_ctx.removeDecimals(_ctx.totalWeekHours)) + " Hours", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.commitmentList && _ctx.commitmentList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "commitment-item commitment-total" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfNonZeroCommitments, (commitment) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: commitment.id,
                            md: "12",
                            class: "commitment-item text-left"
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(commitment.Name), 1),
                            _cache[25] || (_cache[25] = _createTextVNode("   ")),
                            (_ctx.allTimesheetsOfCommitmentHaveBeenApproved(commitment.id))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  color: "success",
                                  "x-small": ""
                                }, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-lock")
                                  ])),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "error",
                                  "x-small": ""
                                }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("mdi-lock-open")
                                  ])),
                                  _: 1
                                })),
                            _cache[26] || (_cache[26] = _createTextVNode("  : "))
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfZeroCommitments, (commitment) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: commitment.id,
                            md: "12",
                            class: "commitment-item text-left"
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(commitment.Name), 1),
                            _cache[27] || (_cache[27] = _createTextVNode("  : "))
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfNonZeroCommitments, (commitment) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "chart-item",
                              style: _normalizeStyle('width:' + (200 * _ctx.hoursOfCommitment(commitment.id)) / _ctx.totalWeekHours + '%;'),
                              key: commitment.id
                            }, _toDisplayString(((100 * _ctx.hoursOfCommitment(commitment.id)) / _ctx.totalWeekHours).toFixed() + "%"), 5))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfNonZeroCommitments, (commitment, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "chart-item",
                              style: _normalizeStyle(`width:${(200 * _ctx.hoursOfCommitment(commitment.id)) / _ctx.totalWeekHours}%; background-color:${commitment.color}`),
                              key: commitment.id
                            }, null, 4))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfZeroCommitments, (commitment) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "chart-item",
                              style: 'width: 0;',
                              key: commitment.id
                            }))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfNonZeroCommitments, (commitment, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "chart-item chart-item--arrow",
                              key: commitment.id,
                              ref_for: true,
                              ref: "arrowContainer",
                              style: _normalizeStyle(_ctx.calcArrowContainerStyle(index))
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["arrow-item", (index + 1) % 2 === 0 ? 'red-border' : 'orange-border']),
                                style: _normalizeStyle(`width:${_ctx.arrowWidths[index]}px; border-color:${commitment.color}`)
                              }, [
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.removeDecimals(_ctx.hoursOfCommitment(commitment.id))) + " Hours", 1)
                              ], 6)
                            ], 4))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfZeroCommitments, (commitment, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "chart-item chart-item--arrow chart-item--zero",
                              key: commitment.id,
                              style: _normalizeStyle('height: ' + (54 + _ctx.listOfNonZeroCommitments.length * 46 + (index + 1) * 46) + 'px')
                            }, [
                              _createElementVNode("span", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.hoursOfCommitment(commitment.id)) + " Hours", 1)
                              ])
                            ], 4))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "12",
                          class: "text-left"
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createElementVNode("strong", null, [
                              _createElementVNode("span", { class: "red--text" }, "This user hasn't any active commitment!")
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showRemoveConfirm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showRemoveConfirm) = $event)),
      onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.showRemoveConfirm = false), ["esc"])),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          onConfirm: _ctx.confirmDelete,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRemoveConfirm = false)),
          loading: _ctx.isDeleting,
          message: _ctx.confirmModel
        }, null, 8, ["onConfirm", "loading", "message"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showAdminActionConfirm,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAdminActionConfirm) = $event)),
      onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.showAdminActionConfirm = false), ["esc"])),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        (_ctx.adminActionFunction)
          ? (_openBlock(), _createBlock(_component_confirm_dialog, {
              key: 0,
              onConfirm: _ctx.adminActionFunction,
              onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAdminActionConfirm = false)),
              loading: _ctx.isDeleting,
              message: _ctx.adminActionModel
            }, null, 8, ["onConfirm", "loading", "message"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showLeaveDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 2,
          persistent: "",
          modelValue: _ctx.showLeaveDialog,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showLeaveDialog) = $event)),
          onKeydown: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.showLeaveDialog = false), ["esc"])),
          "max-width": "600px"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedLeave && _ctx.selectedTeammember)
              ? (_openBlock(), _createBlock(_component_RegisterLeave, {
                  key: 0,
                  onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showLeaveDialog = false)),
                  onSaved: _ctx.leaveSaved,
                  onShowError: _ctx.showErrorMessage,
                  selectedTeammember: _ctx.selectedTeammember,
                  leaveInfo: _ctx.selectedLeave,
                  commitments: _ctx.commitmentList,
                  isAdmin: _ctx.isAdmin
                }, null, 8, ["onSaved", "onShowError", "selectedTeammember", "leaveInfo", "commitments", "isAdmin"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showRegisterTimesheet)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 3,
          persistent: "",
          "max-width": "100%",
          modelValue: _ctx.showRegisterTimesheet,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showRegisterTimesheet) = $event)),
          onKeydown: _withKeys(_ctx.cancel, ["esc"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TimesheetRegister, {
              isAdmin: _ctx.isAdmin,
              teamMemberInfo: _ctx.selectedTeammember,
              date: _ctx.registerDate,
              tmCommitments: _ctx.commitmentList,
              timesheet: _ctx.selectedTimesheet,
              userProjects: _ctx.userProjects,
              regLoading: _ctx.regLoading,
              commitmentColors: _ctx.commitmentColors,
              onCancel: _ctx.cancelRegister,
              onErrorRaised: _ctx.errorRaised,
              onConfirmTimesheet: _ctx.confirmTimesheet,
              onEditTimesheet: _ctx.editTimesheet
            }, null, 8, ["isAdmin", "teamMemberInfo", "date", "tmCommitments", "timesheet", "userProjects", "regLoading", "commitmentColors", "onCancel", "onErrorRaised", "onConfirmTimesheet", "onEditTimesheet"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeydown"]))
      : _createCommentVNode("", true),
    (_ctx.showCloneDialog)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 4,
          persistent: "",
          modelValue: _ctx.showCloneDialog,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showCloneDialog) = $event)),
          onKeydown: _withKeys(_ctx.cancelClone, ["esc"]),
          "max-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_timesheet_clone, {
              onShowErrorMessage: _ctx.showErrorMessage,
              onCancel: _ctx.cancelClone,
              isAdmin: _ctx.isAdmin,
              onConfirmClone: _ctx.confirmClone,
              timesheetInfo: _ctx.selectedTimesheet
            }, null, 8, ["onShowErrorMessage", "onCancel", "isAdmin", "onConfirmClone", "timesheetInfo"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeydown"]))
      : _createCommentVNode("", true),
    (_ctx.showAdjustmentDialog && _ctx.selectedTimesheet)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 5,
          persistent: "",
          modelValue: _ctx.showAdjustmentDialog,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showAdjustmentDialog) = $event)),
          onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showAdjustmentDialog = false), ["esc"])),
          "max-width": "400px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_adjustment, {
              onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showAdjustmentDialog = false)),
              onSaved: _ctx.updatedAdjustment,
              onShowError: _ctx.showErrorMessage,
              id: _ctx.selectedTimesheet.id,
              ad: _ctx.selectedTimesheeatAd
            }, null, 8, ["onSaved", "onShowError", "id", "ad"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}